const translations: Record<string, string> = {
  "ak_dsp4_above_the_rated_power_kw": "Понад паспортну потужність ({{p}} кВт)",
  "ak_dsp4_hr_power_kw_is_above_the_rated_power_k": "Год {{hh}}: потужність {{p}} кВт вища за паспортну ({{max}} кВт)",
  "ak_dsp4_below_pmin_kw": "Нижче Pmin {{p}} кВт",
  "ak_dsp4_charge": "заряд",
  "ak_dsp4_discharge": "розряд",
  "ak_dsp4_hr_kw_is_below_the_minimum_operating_p": "Год {{hh}}: {{mode}} {{p}} кВт нижчий за мінімальну робочу потужність {{pmin}} кВт — установка такої команди не виконає (бракує {{miss}} кВт). Зберіть ці години в меншу кількість повних.",
  "ak_dsp4_overcharge_kwh_free": "Перезаряд: вільно {{r}} кВт·год",
  "ak_dsp4_hr_charge_kwh_does_not_fit_at_soc_ther": "Год {{hh}}: заряд {{p}} кВт·год не влізе — при SOC {{soc}}% до стелі {{max}}% лишилось {{room}} кВт·год (надлишок {{over}})",
  "ak_dsp4_below_the_limit_kwh_available": "Нижче межі {{min}}%: доступно {{a}} кВт·год",
  "ak_dsp4_hr_discharge_kwh_takes_the_bess_below": "Год {{hh}}: розряд {{p}} кВт·год опускає УЗЕ нижче робочих {{min}}% — при SOC {{soc}}% доступно {{a}} кВт·год (бракує {{miss}})",
  "ak_dsp4_kw": "кВт",
  "ak_dsp4_kwh": "кВт·год",
  "ak_dsp4_working_range": "· робочий діапазон {{a}}–{{b}}%",
  "ak_dsp4_can_charge": "Можна зарядити:",
  "ak_dsp4_can_discharge": "Можна розрядити:",
  "ak_dsp4_soc_at_end_of_day": "SOC на кінець доби:",
  "ak_dsp4_charge_losses_discharge_at_the_connect": "заряд ×{{c}} (втрати) · розряд ÷{{d}} у приєднанні",
  "ak_dsp4_command_from_kw": "команда від {{p}} кВт",
  "ak_dsp4_and_more": "…та ще {{n}}",
  "ak_dsp4_solar_charge_discharge": "Сонячна {{pv}} · Заряд −{{ch}} · Розряд +{{dis}} ·",
  "ak_dsp4_total_mwh": "Разом {{n}} МВт·год",
  "ak_dsp4_mwh": "МВт·год",
  "ak_dsp4_bess_schedule_saved_the_net_forecast_h": "Графік УЗЕ збережено — підсумковий прогноз оновлено.",
  "ak_dsp4_failed_to_save": "Не вдалося зберегти",
  "ak_dsp4_schedule_proposed_review_and_save_it": "Графік запропоновано — перевірте й збережіть.",
  "ak_dsp4_autofill_unavailable": "Автозаповнення недоступне",
  "ak_dsp4_bess_charge_discharge_schedule": "Графік заряду/розряду УЗЕ",
  "ak_dsp4_charging_reduces_discharging_increases": "Заряд зменшує, розряд збільшує підсумковий прогноз",
  "ak_dsp4_bess_charge_at_start_of_day": "Заряд УЗЕ на початок доби:",
  "ak_dsp4_bess_charge_now": "Заряд УЗЕ зараз:",
  "ak_dsp4_no_telemetry": "немає телеметрії",
  "ak_dsp4_from_telemetry_history": " (з історії телеметрії)",
  "ak_dsp4_stale": " (застаріла)",
  "ak_dsp4_pcs_in_fault": " (PCS у fault)",
  "ak_dsp4_autofill_propose_a_schedule_automatica": "Автозаповнення: запропонувати графік автоматично",
  "ak_dsp4_save_bess_schedule": "Зберегти графік УЗЕ",
  "ak_dsp4_collapse_hourly_data": "Згорнути погодинні дані",
  "ak_dsp4_hourly_data": "Погодинні дані",
  "ak_dsp4_start_soc": "Старт SOC",
  "ak_dsp4_restore_telemetry": "повернути телеметрію",
  "ak_dsp4_technically_impossible_values_fix_them": "Технічно неможливі значення — виправте, щоб зберегти:",
  "ak_dsp4_the_bess_balance_does_not_add_up_for_a": "Баланс УЗЕ не сходиться — для минулої доби це лише попередження, зберегти можна",
  "ak_dsp4_charge_2": "Заряд",
  "ak_dsp4_discharge_2": "Розряд",
  "ak_dsp4_net_forecast_solar_generation_bess": "Підсумковий прогноз (сонячна генерація + УЗЕ)",
  "ak_dsp4_solar_generation": "Сонячна генерація",
  "ak_dsp4_bess_discharge": "Розряд УЗЕ",
  "ak_dsp4_bess_charge": "Заряд УЗЕ",
  "ak_dsp4_net": "Підсумок",
  "ak_dsp4_hr": "Год",
};

export default translations;
